export const width=359;export const height=611;export default{width:width,height:height};